import React, { Component } from 'react';
import ApxViewReport from './ApxViewReport';
import AccountManagement from './AccountManagement';
import css from './ApxView.module.css';
import cssMain from './Main.module.css';
import VerticalNavigationAPX from './../Components/VerticalNavigationAPX.jsx';
import { APXModules } from './../Enums/Enums';

class ApxView extends Component {
  constructor(props) {
    super(props);

    this.props.data.APX.APXModuleCallback = this.verticalMenuChange.bind(this);
    this.handleChangeValue = this.handleChangeValue.bind(this);
    this.navigationHasItems = false;
    this.currentview = APXModules.Default;

    this.state = {
      moduleView: APXModules.Default
    }
  }

  handleChangeValue(items) {
    this.navigationHasItems = items.length > 0;
    if (this.navigationHasItems)
      this.setState({ moduleView: items[0].value });
  }

  verticalMenuChange(value, index) {
    this.setState({ moduleView: value });
  }

  render() {
    return (
      <div style={{ width: "100%", height: "calc(100vh - 100px)" }}>
        <div className={css.vertical_menu}>
          {<VerticalNavigationAPX data={this.props.data} getItemList={this.handleChangeValue} items={[{ text: "Reports", value: "APXReports", isActive: true }, { text: "Transaction", value: "Transaction" }, { text: "Onboarding", value: "Onboarding" }, { text: "Endpoints", value: "Endpoints" }, { text: "Account Management", value: "AccountManagement" }]}></VerticalNavigationAPX>}
        </div>
        <div className={cssMain.scroll_area}>                
          {(this.state.moduleView === APXModules.Reports) ? <ApxViewReport data={this.props.data}></ApxViewReport> : null}
          {(this.state.moduleView === APXModules.AccountManagement) ? <AccountManagement data={this.props.data}></AccountManagement> : null}
        </div>
      </div>
    );
  }
}

export default ApxView;